import React from 'react';

import Home from './Home';

import './home.less';

const HomeImpersonations = ({ context }) => (
  <Home
    context={context}
    dashboard="dashboard_home_impersonation"
    translation="home"
  />
);

export default HomeImpersonations;
